// src/pages/clientes/components/DeleteClienteModal.tsx
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '@/components/ui';
import { useEliminarCliente } from '@/hooks/queries/useClientes';
import type { Cliente } from '@/types';
import { AlertTriangle } from 'lucide-react';

interface Props {
  open: boolean;
  onClose: () => void;
  cliente: Cliente | null;
}

export function DeleteClienteModal({ open, onClose, cliente }: Props) {
  const eliminarMutation = useEliminarCliente();

  const handleDelete = async () => {
    if (!cliente) return;
    try {
      await eliminarMutation.mutateAsync(cliente.id);
      onClose();
    } catch {
      // Error handled by mutation
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent size="sm">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <div>
              <DialogTitle>Eliminar Cliente</DialogTitle>
              <DialogDescription>
                Esta acción no se puede deshacer
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-gray-600">
            ¿Estás seguro de que deseas eliminar al cliente{' '}
            <span className="font-semibold">{cliente?.nombre}</span>?
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Todos los datos asociados (empresas, contactos, tickets, conversaciones)
            serán desactivados.
          </p>
        </div>

        <DialogFooter>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            loading={eliminarMutation.isPending}
          >
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
